import { ConnectionGraphicProperties } from './3D/graphic-properties/connection-graphic-properties.model';
import { Point3d } from './point3d.model';
import { ReferenceType } from './reference-type.enum';

export class Connection {
  id: number;
  title: string;
  internalId: number;
  localCoordinates: Point3d;
  referenceId: number;
  reference: ReferenceType;
  needsUpdate?: boolean;
  graphicProperties?: ConnectionGraphicProperties;

  constructor() {}
}
